var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"space":true}},[_c('b-container',[_c('h2',{staticClass:"title"},[_vm._v("Продукти")]),_c('b-row',[_c('the-preview-products',{attrs:{"search":_vm.search}}),_c('the-preview-cart')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }